import { render, staticRenderFns } from "./WebPagesMenuEditor.vue?vue&type=template&id=77c123bc&"
import script from "./WebPagesMenuEditor.vue?vue&type=script&lang=js&"
export * from "./WebPagesMenuEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports